module.exports = __webpack_public_path__ + "static/media/43-5.7b738952.mp3";